export type FlagKey =
  | "backoffice-test-feature"
  | "backoffice-member-feedback-toggle"
  | "backoffice-algolia-person-index"
  | "backoffice-prorated-product-price"
  | "backoffice-background-check-staff-create-order"
  | "backoffice-activities-screen"
  | "backoffice-manage-lifelong-learning"
  | "backoffice-lifelong-learning-applications"
  | "backoffice-application-authorizations-index"
  | "backoffice-facility-section-change"
  | "backoffice-facility-merge-purge"
  | "backoffice-person-merge-membership-bands"
  | "backoffice-uncollectible-orders"
  | "m360-timeline"
  | "pga-career-targets"
  | "pga-career-plan"
  | "backoffice-create-test-person"
  | "backoffice-grp"
  | "commission-grp-platform"
  | "commission-grp-facility-profile"
  | "backoffice-grp-person-profile"
  | "backoffice-member-programs-and-benefits"
  | "backoffice-section-governance"
  | "backoffice-section-roster-activity"
  | "backoffice-person-profile-documents"
  | "backoffice-pat-result-volume"
  | "m360-department-task-queue"
  | "m360-quick-action-menus-redesign"
  | "m360-private-team-task-visibility"
  | "backoffice-settings-hub"
  | "backoffice-system-preferences"
  | "backoffice-navigation-preferences"
  | "backoffice-pgm-transcript-print"
  | "backoffice-job-applicant-count-estimate"
  | "backoffice-prospect-program-tab"
  | "backoffice-birthday-greeting-per-consultant"
  | "backoffice-message-templates-career-services"
  | "backoffice-event-banner-image"
  | "applications-membership"
  | "membership-sms-consent"
  | "membership-reciprocity-applications"
  | "backoffice-pdr-gate-cohort-tool"
  | "education-graduation-date-edit"
  | "backoffice-member-eligibility-export"
  | "backoffice-pbd-review-photo-replacement-email"
  | "backoffice-hide-prospect-active-status-tag"
  | "backoffice-leaf-fall-logo"
  | "backoffice-attendance-finalization-by-credit-config"
  | "backoffice-associate-dashboard-expanded-access"
  | "m360-eve-chat";

export const ATTENDANCE_FINALIZATION_BY_CREDIT_CONFIG_FLAG =
  "backoffice-attendance-finalization-by-credit-config" satisfies FlagKey;

export const ASSOCIATE_DASHBOARD_EXPANDED_ACCESS_FLAG =
  "backoffice-associate-dashboard-expanded-access" satisfies FlagKey;

export const MEMBER_ELIGIBILITY_EXPORT_FLAG = "backoffice-member-eligibility-export" satisfies FlagKey;

export const PBD_REVIEW_PHOTO_REPLACEMENT_EMAIL_FLAG =
  "backoffice-pbd-review-photo-replacement-email" satisfies FlagKey;

export const MEMBERSHIP_SMS_CONSENT_FLAG = "membership-sms-consent" satisfies FlagKey;

export const PDR_GATE_COHORT_TOOL_FLAG = "backoffice-pdr-gate-cohort-tool" satisfies FlagKey;

export const EVE_CHAT_FLAG = "m360-eve-chat" satisfies FlagKey;

export const BIRTHDAY_GREETING_PER_CONSULTANT_FLAG: FlagKey = "backoffice-birthday-greeting-per-consultant";

export const MESSAGE_TEMPLATES_CAREER_SERVICES_FLAG: FlagKey = "backoffice-message-templates-career-services";

/** Message Templates is reachable when either family's flag is on; the backend lists only that family's types. */
export function messageTemplatesEnabled(flags: FlagRecord): boolean {
  return Boolean(flags[BIRTHDAY_GREETING_PER_CONSULTANT_FLAG] || flags[MESSAGE_TEMPLATES_CAREER_SERVICES_FLAG]);
}

export type FlagValue = boolean | string;

export type FlagRecord = Partial<Record<FlagKey, FlagValue>>;
